import { css } from 'emotion';
import React from 'react';
//@ts-ignore
import Barcode from 'react-barcode';

const barcodeWrapper = css`
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Barcodes = ({ barcodes }: any) => {
  return (
    <div>
      {barcodes.map((barcode: any, j: number) => (
        <div
          className={barcodeWrapper}
          key={`image-page-${j.toString()}`}
          style={{
            borderBottomWidth: `${barcode.borderBottomWidth}mm`,
            borderLeftWidth: `${barcode.borderLeftWidth}mm`,
            borderRightWidth: `${barcode.borderRightWidth}mm`,
            borderTopWidth: `${barcode.borderTopWidth}mm`,
            color: barcode.color,
            fontFamily: barcode.fontFamily,
            fontSize: `${barcode.fontSize}mm`,
            height: `${barcode.height}mm`,
            left: `${barcode.left}mm`,
            lineHeight: `${barcode.lineHeight}mm`,
            position: 'absolute',
            top: `${barcode.top}mm`,
            transform: `rotateZ(${barcode.rotation}deg)`,
            width: `${barcode.width}mm`,
            zIndex: 5,
          }}
        >
          <Barcode value="0001111" />
        </div>
      ))}
    </div>
  );
};
